import { useTranslation } from 'react-i18next';

import { Body1, Stack, Subtitle1 } from '@myphx-engineering/phx-design-system';
import { IllustrationCard, LocationFailedIllustration } from '@phx/myphx-lib';

export const NoLocation = () => {
    const { t } = useTranslation();

    return (
        <IllustrationCard
            illustrationPosition="top"
            Illustration={LocationFailedIllustration}
            illustrationSize="lg"
            variant="bare"
            withShadow={false}
        >
            <Stack gap="xs">
                <Subtitle1 ta="center">
                    {t('providerOffers.noLocation.title')}
                </Subtitle1>
                <Body1 ta="center">
                    {t('providerOffers.noLocation.description')}
                </Body1>
            </Stack>
        </IllustrationCard>
    );
};
